import {
    RECEIVE_CART_AND_USER_PROFILE,
    ADD_TO_CART,
    SET_AMOUNT,
    ERROR,
    SUCCESS,
} from './types';
import { showLoading, hideLoading } from 'react-redux-loading-bar';
import { users } from '../firebase';
import { userSignedIn } from '../selectors';

const receiveCartAndUserProfile = (data) => {
    return {
        type: RECEIVE_CART_AND_USER_PROFILE,
        payload: data,
    };
};

const cartError = (err) => {
    return {
        type: ERROR,
        payload: err.message,
    };
};
export const addToCart = (sku, amount, history) => async (
    dispatch,
    useState
) => {
    if (userSignedIn(useState())) {
        dispatch({
            type: ADD_TO_CART,
            sku,
            amount,
        });
        dispatch({
            type: SUCCESS,
            payload: 'Add to cart successful',
        });
        dispatch(uploadCart());
    } else {
        history.push({
            pathname: '/signup',
            state: { from: history.location },
        });
    }
};

export const changeAmount = (sku, amount) => async (dispatch) => {
    dispatch({
        type: SET_AMOUNT,
        sku,
        amount,
    });
    dispatch(uploadCart());
};

export const uploadCart = () => async (dispatch, getState) => {
    dispatch(showLoading());
    users
        .doc(getState().user.uid)
        .set({ cart: getState().cart }, { merge: true })
        .then(() => {
            dispatch(hideLoading());
        })
        .catch((err) => dispatch(cartError(err)));
};

export const fetchCartAndUserProfile = (uid) => async (dispatch, getState) => {
    dispatch(showLoading());
    users
        .doc(uid)
        .get()
        .then((doc) => {
            dispatch(receiveCartAndUserProfile(doc.data()));
            dispatch(hideLoading());
        });
};
